export const language = {
  zh: {
    'More': '更多 >',
    'New Products': '新品推荐',
  },
  en: {
    'More': 'More >',
    'New Products': 'New Products'
  }
};